import React, { FC, forwardRef, RefAttributes } from 'react';
import { DatePicker, Dropdown } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { get } from 'lodash';
import { SUPPORTED_LOCALES } from '@trip-ux/constants';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';

export const MaintenanceDatePicker: FC<
  FieldRenderProps<string> &
    RefAttributes<HTMLInputElement> & {
      ariaLabel: string;
      disabledDays?: {
        before?: Date;
        after?: Date;
      };
      onChange?: (val) => void;
    }
> = forwardRef(
  (
    {
      labels,
      ariaLabel,
      input,
      meta,
      showLabel = false,
      className = '',
      disabled = false,
      id,
      disabledDays,
      onChange,
      isSearch = false
    },
    ref
  ) => {
    const { locale } = useSelector((store: ReduxStore) => ({
      locale: get(store, 'config.locale')
    }));
    return (
      <div className={className}>
        <DatePicker
          {...input}
          disabledDays={disabledDays}
          id={id ? id : input.name}
          dateFormat={labels.datePickerLabels.dateFormat}
          disabled={disabled}
          className="my-auto date-picker-policy"
          labels={{ ...labels.datePickerLabels, placeholder: ariaLabel }}
          language={locale as SUPPORTED_LOCALES}
          required={false}
          defaultValue={meta.initial || ''}
          ref={ref}
          showLabel={showLabel}
          errors={!disabled && meta.error}
          isSearch={isSearch}
          onBlur={val => {
            input.onChange(val);
            onChange && onChange(val);
          }}
          onChange={val => {
            input.onChange(val);
            onChange && onChange(val);
          }}>
          {ariaLabel}
        </DatePicker>
      </div>
    );
  }
);
MaintenanceDatePicker.displayName = 'MaintenanceDatePicker';

export const MaintenanceDropdown: FC<
  FieldRenderProps<string> & { ariaLabel?: string; showErrorOnUntouched?: boolean }
> = ({
  labels,
  input,
  meta,
  className = '',
  disabled = false,
  id,
  options,
  language,
  placeholder,
  showErrorOnUntouched = false
}) => (
  <div className={`mb-auto space-between ${className}`}>
    <Dropdown
      {...input}
      placeholder={placeholder}
      id={id ? id : input.name}
      isDisabled={disabled}
      className="my-auto text-input-policy"
      error={showErrorOnUntouched ? meta.error : meta.touched && meta.error}
      options={options}
      language={language}>
      {get(labels, input.name, '')}
    </Dropdown>
  </div>
);

MaintenanceDropdown.displayName = 'MaintenanceDropdown';
